import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ModalController} from '@ionic/angular';
import { AscentListEntry } from 'src/model/ascent-list-entry';

@Component({
  selector: 'app-ascent-list',
  templateUrl: './ascent-list.page.html',
  styleUrls: ['./ascent-list.page.scss'],
})
export class AscentListPage implements OnInit {

  username: string;

  constructor(private activatedRoute: ActivatedRoute, private modalCtrl: ModalController) {
  }

  ngOnInit() {
    if (!this.username) {
      this.username = this.activatedRoute.snapshot.paramMap.get('username');
    }
  }

  /**
   * If there is a modal, we assume this page is part of it and dismiss it.
   */
  async backButtonPressed() {
    const top = await this.modalCtrl.getTop();
    if (top) {
      await top.dismiss();
    }
  }
}
